import Vue from 'vue';
import '@/assets/stylesheets/components/_mini-app-preview.scss';
import DiyPreviewDrawerMixin from '@/helpers/vue_mixins/v2/DiyPreviewDrawerMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
export default Vue.extend({
    mixins: [DiyPreviewDrawerMixin, ViewportSizeMixin],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    render(createElement) {
        const self = this;
        if (this.show) {
            return createElement('div', { class: 'text-xs-right' }, [
                createElement('v-btn', {
                    props: {
                        icon: self.smOnly || self.mdOnly,
                        light: self.smOnly || self.mdOnly,
                        flat: self.xsOnly,
                    },
                    on: {
                        click: self.hideMiniAppPreview,
                    },
                }, [createElement('v-icon', {}, ['close'])]),
            ]);
        }
        return createElement();
    },
});
